module.exports = __webpack_public_path__ + "static/logo-697b539967fb754bb693a47f43168a89.svg";